import React, { useEffect, useState } from 'react';
import { config } from '../../../../../../../config';
import axiosApi from '../../../../../../../core/interceptor/interceptor';
import {
  // Link,
  withRouter,
  useHistory
} from 'react-router-dom';
// import add from '../../../../../../../assets/add-icon.svg';
// import WarningDialogue from '../../../../../../../Util/WarningDialogue';
// import { messages } from '../../../../../../../messages';
// import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { loadColumns } from '../../../../../../../Util/helper';
import DataTableComponent from '../../../../../../../Util/DataTable/DataTable';
import './Template.css';

function Templates() {
  const history = useHistory();
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [filter, setFilter] = useState({
    limit: 50,
    page: 1,
    direction: 'asc',
  });
  // const [popUpContent, setPopUpContent] = useState({});
  // const [showDeletePopup, setShowDeletePopup] = useState(false);
  useEffect(() => {
    getData(filter);
  }, [
    filter,
    filter.limit,
    filter.page,
    filter.direction,
    filter.sort_column,
  ]);
  useEffect(() => {
    setColumns([
      {
        name: 'Type',
        selector: 'type',
        type: 'template_type',
      },
      {
        name: 'Template Details',
        selector: 'body',
      },
      {
        name: 'Action',
        selector: 'table_action',
        sortable: false,
        type: 'templates_action',
        actionHandler: function (id) {
          deleteTemplate(id);
        },
      }
    ])
    // eslint-disable-next-line
  }, []);
  const getData = (params) => {
    axiosApi.get(`${config.apiUrl}/templates/get-templates`, { params })
      .then((res) => {
        setData(res?.data?.data);
      })
  }
  const handleChangeTable = (e) => {
    if (e.type === 'sort') {
      setFilter(prev => {
        const filter_ = {
          ...prev,
          [e.target.name]: e.target.value,
          direction: e.target.direction,
        };
        return filter_;
      });
    } else {
      setFilter(prev => {
        const filter_ = {
          ...prev,
          [e.target.name]: e.target.value,
        };
        return filter_;
      })
    }
  }
  const deleteTemplate = (id) => {
    history.push(`./templates/edit-template/${id}`)
    // setShowDeletePopup(true);
    // setPopUpContent({
    //   header: 'Delete',
    //   description: messages.deleteTemplate,
    //   icon: faExclamationTriangle,
    //   action: () => {
    //     axiosApi.delete(`${config.apiUrl}/templates/${id}`)
    //       .then(() => {
    //         setShowDeletePopup(false);
    //         getData(filter);
    //       }).catch((err) => {
    //         setShowDeletePopup(false);
    //       })
    //   }
    // })
  }

  return (
    <>
      <div className="content-wrapper message-template-wrapper">
        <div className="heading-wrapper">
          <div class="left">
            <h1 class="heading">SMS Templates</h1>
            <p>Select a row to modify template</p>
          </div>
          {/* <div class="right">
            <Link to={{
              pathname: `/admin/settings/templates/add-template`
            }}>
              <div className='right'><button><img src={add} alt='add-league' />Add Template</button></div>
            </Link>
          </div> */}
        </div>
        <div className="table-wrapper">
          <div className="heading-blk">
            <div className="left">
              <h2>Results</h2>
              <p>Select a template to modify.</p>
            </div>
          </div>
          <div className='dataTable active'>
            <DataTableComponent
              data={data}
              columns={loadColumns({ columns })}
              disableRowClicked={false}
              onFilterChange={handleChangeTable}
              type={'templates'}
            />
          </div>
        </div>
      </div>
      {/* <WarningDialogue
        isOpen={showDeletePopup}
        header={popUpContent.header}
        description={popUpContent.description}
        icon={popUpContent.icon}
        action={popUpContent.action}
        onClose={() => setShowDeletePopup(false)}
      /> */}
    </>
  )
}
export default withRouter(Templates);